import { render, staticRenderFns } from "./FormPostcode.vue?vue&type=template&id=15026774&scoped=true&"
import script from "./FormPostcode.vue?vue&type=script&lang=js&"
export * from "./FormPostcode.vue?vue&type=script&lang=js&"
import style0 from "./FormPostcode.vue?vue&type=style&index=0&id=15026774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15026774",
  null
  
)

export default component.exports